export enum ReconnectionStateType {
  INITIAL,
  FORCE_RELAY,
  FORCE_TCP,
}

export interface PeerStats {
  timestamp: number;
  // Inbound
  packetsReceived: number;
  bytesReceived: number;

  // Outbound
  packetsSent: number;
  bytesSent: number;
  mediaSourceId: string;

  // Packet Loss
  packetsLost: number;
  videoPacketsLost: number;
  audioPacketsLost: number;
  // jitter
  audioJitter: number;
  audioJitterBufferDelay: number;
  videoJitter: number;
  videoJitterBufferDelay: number;
  audioPacketsReceived: number;
  audioLevel: number;

  // video
  firCount: number;
  frameHeight: number;
  framesDropped: number;
  framesEncoded: number;
  framesPerSecond: number;
  framesReceived: number;
  framesSent: number;
  frameWidth: number;
  keyFramesEncoded: number;
  limitationDuration: number;
  nackCount: number;
  outboundQLR: string;
  pliCount: number;
  targetBitrate: number;
}

export interface InSnapshots {
  bytesReceived: number[];
  headerBytesReceived: number[];
  packetsReceived: number[];
  packetsLost: number[];
  framesReceived?: number[];
}

export interface OutSnapshots {
  packetsSent: number[];
  bytesSent: number[];
  headerBytesSent: number[];
  retransmittedBytesSent: number[];
  retransmittedPacketsSent: number[];
  framesSent?: number[];
}
